export default "__VITE_ASSET__652c5e4e__"